/* Shared behaviour for every BLANKD section: reveal-on-scroll, nothing else.
   Section-specific logic lives in that section's own asset. */
(() => {
  const els = [...document.querySelectorAll(".bdx-rv:not(.in)")];
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("in")); return; }
  const io = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
  }), { rootMargin: "0px 0px -8% 0px" });
  els.forEach((el, i) => { el.style.transitionDelay = `${(i % 4) * 60}ms`; io.observe(el); });
})();
